import { Dispatch } from "react";
import API from "../../services/api";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";

export interface LoadTagsAction
{
    type: "LOAD_TAGS_SUCCESS";
    tags: string[];
}

export interface RemoveTagAction
{
    type: "REMOVE_TAG";
    tag: string;
  
}

export const loadTags = () => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const { tags } = await API.tag.getTags();
        const action: LoadTagsAction = {type: "LOAD_TAGS_SUCCESS", tags };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading Tags failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const removeTag = (tag: string) => async (dispatch: Dispatch<any>) =>
{
    try 
    {
        await API.tag.removeTag(tag);
        const action: RemoveTagAction = {type: "REMOVE_TAG", tag };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Removing tag failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export type TagActions = LoadTagsAction | RemoveTagAction;


// WEBPACK FOOTER //
// ./src/state/tag/action.ts